import i18n from 'i18next';
import * as Yup from 'yup';

export const appConfigurationFormSchema = Yup.object().shape({
  name: Yup.string().required(() => i18n.t('validation:forms.fieldRequired')),
  max_body_size: Yup.number().max(100, () => i18n.t('validation:MustNotMoreThan', { amount: 100 })),
  max_post_argument: Yup.number().max(200, () => i18n.t('validation:MustNotMoreThan', { amount: 200 })),
  max_url_argument: Yup.number().max(200, () => i18n.t('validation:MustNotMoreThan', { amount: 200 })),
});
